import React, {Suspense} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import Completed, {CompletedProps} from './completed'
import InProgress, {InProgressProps} from './in-progress'
import Placeholder from './placeholder'
import Diverged from './diverged'

const propTypes = {
  status: PropTypes.string,
  small: PropTypes.bool,
}
const defaultProps = {
  status: undefined as undefined | null,
  small: false,
}

type ShipmentStatusProps = InferPropTypes<typeof propTypes, typeof defaultProps> &
  CompletedProps &
  InProgressProps

const ShipmentStatus: React.FC<ShipmentStatusProps> = ({status, ...restProps}) => {
  switch (status) {
    case 'COMPLETED':
      return (
        <Suspense fallback={<Placeholder {...restProps} />}>
          <Completed {...restProps} />
        </Suspense>
      )
    case 'IN_PROGRESS':
      return (
        <Suspense fallback={<Placeholder {...restProps} />}>
          <InProgress {...restProps} />
        </Suspense>
      )
    case 'DIVERGED':
      return (
        <Suspense fallback={<Placeholder {...restProps} />}>
          <Diverged {...restProps} />
        </Suspense>
      )
    case 'PLACEHOLDER':
      return <Placeholder {...restProps} />
    default:
      return null
  }
}

ShipmentStatus.propTypes = propTypes
ShipmentStatus.defaultProps = defaultProps

export default ShipmentStatus
